export const discountActionTypes = {
    STORE_DISCOUNTS: "STORE_DISCOUNTS",
    STORE_SERVICES: "STORE_SERVICES"
}